import axios from "./axios.interceptors";
import type { AxiosResponse } from "axios";

class NewsLetterService {
  public newsletterSubscribe = async (
    body: any
  ): Promise<AxiosResponse<string>> => {
    return axios.post<string>("/api/newsletter/subscribe", body);
  };
}

export default new NewsLetterService();
